import { convertToPrice } from "../../utils/functions/currencies";

export const PlanBodyTemplate = (rowData: any) => {
  return (
    <div className="flex align-items-center gap-2 w-full">
      {!!rowData.planName ? (
        <>
          <p className="p-0 h-0">{rowData.planName}</p>
          <span>{convertToPrice(rowData.planPrice)}</span>
        </>
      ) : (
        <p className="p-0 h-0">Sin plan</p>
      )}
    </div>
  );
};
